import { MessageBar, MessageBarBody } from '@fluentui/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import './EmptyLessonCardEntry.scss';

export const EmptyLessonCardEntry: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="emptyLessonCardEntryAlert">
      <MessageBar intent="info">
        <MessageBarBody>
          {t('classbook:emptylessoncard_empty', {
            defaultValue: 'Es sind keine Einträge vorhanden.',
          })}
        </MessageBarBody>
      </MessageBar>
    </div>
  );
};
